import React from "react";

export const TaskContext = React.createContext();
export const FinishedTaskContext = React.createContext();